import { Euler } from 'three'

export const deviceScaleAndRotation = {
  mobile_portrait: {
    xs: {
      rotation: new Euler(0.1, 0.2, 0),
      scale: 0.05,
    },
    sm: {
      rotation: new Euler(0.1, 0.2, 0),
      scale: 0.05,
    },
    md: {
      rotation: new Euler(0.1, 0.2, 0),
      scale: 0.06,
    },
    lg: {
      rotation: new Euler(-0.2, -0.4, -0.2),
      scale: 0.055,
    },
    xl: {
      rotation: new Euler(-0.4, -0.4, -0.3),
      scale: 0.055,
    },
  },
  mobile_landscape: {
    xs: {
      rotation: new Euler(0.1, 0.2, 0),
      scale: 0.05,
    },
    sm: {
      rotation: new Euler(0.1, 0.2, 0),
      scale: 0.05,
    },
    md: {
      rotation: new Euler(0.1, 0.2, 0),
      scale: 0.06,
    },
    lg: {
      rotation: new Euler(-0.2, -0.4, -0.2),
      scale: 0.055,
    },
    xl: {
      rotation: new Euler(-0.4, -0.4, -0.3),
      scale: 0.055,
    },
  },
  tablet_landscape: {
    xs: {
      rotation: new Euler(0, 0, 0),
      scale: 0.06,
    },
    sm: {
      rotation: new Euler(0, 0, 0),
      scale: 0.08,
    },
    md: {
      rotation: new Euler(0, 0, 0),
      scale: 0.08,
    },
    lg: {
      rotation: new Euler(-0.2, -0.3, -0.2),
      scale: 0.06,
    },
    xl: {
      rotation: new Euler(-0.2, -0.3, -0.2),
      scale: 0.07,
    },
  },
  tablet_portrait: {
    xs: {
      rotation: new Euler(0, 0, 0),
      scale: 0.06,
    },
    sm: {
      rotation: new Euler(0, 0, 0),
      scale: 0.07,
    },
    md: {
      rotation: new Euler(0, 0, 0),
      scale: 0.07,
    },
    lg: {
      rotation: new Euler(-0.2, -0.3, -0.2),
      scale: 0.05,
    },
    xl: {
      rotation: new Euler(-0.2, -0.3, -0.2),
      scale: 0.06,
    },
  },
  desktop: {
    xs: {
      rotation: new Euler(0, 0, 0),
      scale: 0.05,
    },
    sm: {
      rotation: new Euler(0, -0.1, 0),
      scale: 0.06,
    },
    md: {
      rotation: new Euler(0, -0.1, 0),
      scale: 0.06,
    },
    lg: {
      rotation: new Euler(0, -0.7, 0),
      scale: 0.051,
    },
    xl: {
      rotation: new Euler(0, -0.7, 0),
      scale: 0.05,
    },
  },
}
